import { createEntityTouchSelect } from './helpers/createEntityTouchSelect';
import { usePurchaseOrdersList } from './SelectPurchaseOrder';

import { QueryHookResult } from '~/shared/providers/api/createQueryHook';

export type SelectablePurchaseOrderTouch = QueryHookResult<
  typeof usePurchaseOrdersList
>[number];

const formatLabel = (entity: SelectablePurchaseOrderTouch): string => {
  const parts = [`#${entity.documentNumber}`];
  if (entity.account?.name) {
    parts.push(`- ${entity.account.name}`);
  }
  return parts.join(' ');
};

export const SelectPurchaseOrderTouch =
  createEntityTouchSelect.remotelySearched(
    'SelectPurchaseOrder',
    usePurchaseOrdersList,
    {
      formatLabel,
      formatSubLabel: (entity) => entity.status,
    },
  );
